type GtagFn = (...args: unknown[]) => void;

declare global {
  interface Window {
    gtag?: GtagFn;
    dataLayer?: unknown[];
  }
}

function safeGtag(...args: unknown[]): void {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag(...args);
  }
}

export function trackEvent(eventName: string, params?: Record<string, string>): void {
  safeGtag('event', eventName, params);
}

export function trackLeadGeneration(source: string): void {
  trackEvent('generate_lead', { lead_source: source });
}

export function trackRequestQuoteClick(buttonText: string): void {
  trackEvent('request_quote_click', {
    button_text: buttonText,
    page_path: typeof window !== 'undefined' ? window.location.pathname : '',
  });
}

export function trackPhoneClick(): void {
  trackEvent('phone_click', {
    page_path: typeof window !== 'undefined' ? window.location.pathname : '',
  });
}

export function trackEmailClick(): void {
  trackEvent('email_click', {
    page_path: typeof window !== 'undefined' ? window.location.pathname : '',
  });
}